module.exports = __webpack_public_path__ + "img/tpay.f389746a.svg";